const appLoading = 'appLoading'
const state = {
  appLoading: false
}
const mutations = {
  [appLoading] (state, loading) {
    state.appLoading = loading
  }
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
